import { render, staticRenderFns } from "./Seminars.vue?vue&type=template&id=97353062&scoped=true"
import script from "./Seminars.vue?vue&type=script&lang=js"
export * from "./Seminars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97353062",
  null
  
)

export default component.exports